/** The default font size used by modern browsers, upon which REM units are based. */
const rootFontSizePixels = 16

/**
 * Converts a numeric pixel value to a REM unit string suitable for CSS output.
 * Accepts up to 4 values in the standard CSS shorthand order: top, right,
 * bottom, left.
 *
 * REM units are useful for creating a consistent visual scale across an
 * application because they are based on the root font size, meaning they will
 * adjust to match the user-specific font size settings. This makes them ideal
 * for values like padding, margin, and font sizes, but not for fixed-size
 * elements like shadows, borders, or corner radii, where you should still use
 * pixels to maintain consistency.
 */
export function getPxAsRem(valuePixels: number): string
export function getPxAsRem(
    blockValuePixels: number,
    inlineValuePixels: number
): string
export function getPxAsRem(
    blockStartValuePixels: number,
    inlineValuePixels: number,
    blockEndValuePixels: number
): string
export function getPxAsRem(
    blockStartValuePixels: number,
    inlineEndValuePixels: number,
    blockEndValuePixels: number,
    inlineStartValuePixels: number
): string
export function getPxAsRem(
    valuePixels1: number,
    valuePixels2?: number,
    valuePixels3?: number,
    valuePixels4?: number
): string {
    if (
        valuePixels2 !== undefined &&
        valuePixels3 !== undefined &&
        valuePixels4 !== undefined
    ) {
        return `${valuePixels1 / rootFontSizePixels}rem ${valuePixels2 / rootFontSizePixels}rem ${valuePixels3 / rootFontSizePixels}rem ${valuePixels4 / rootFontSizePixels}rem`
    } else if (valuePixels2 !== undefined && valuePixels3 !== undefined) {
        return `${valuePixels1 / rootFontSizePixels}rem ${valuePixels2 / rootFontSizePixels}rem ${valuePixels3 / rootFontSizePixels}rem`
    } else if (valuePixels2 !== undefined) {
        return `${valuePixels1 / rootFontSizePixels}rem ${valuePixels2 / rootFontSizePixels}rem`
    } else {
        return `${valuePixels1 / rootFontSizePixels}rem`
    }
}
